var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-navi-un-login" }, [
    _c("p", { staticClass: "global-navi-login-appeal" }, [
      _vm._v("ログインして便利に使おう！"),
    ]),
    _vm._v(" "),
    _c(
      "a",
      { staticClass: "global-navi-btn-login", attrs: { href: _vm.loginUrl } },
      [_vm._v("ログイン・メンバー登録")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }